export default function Testimonial() {
  return (
    <div className="testimonial">
      <div className="testifier">
        <img src="./assets/testimonial/New Woyessa.png" alt="Woyessa Woka" />
        <div>
          <h2>Woyessa Woka</h2>
          <h4>Founder & Executive Director</h4>
          <h4>HALE: Human Rights and Inclusion Network</h4>
        </div>
      </div>
      <div className="testimony">
        <p>
          I had the pleasure of working with Yishak on the development of our website for HALE: Human Rights and Inclusion Network.
          His unique design choices truly set our site apart, blending creativity with functionality in a way that resonates with
          our mission. Yishak's innovative approach not only enhanced the visual appeal, but also improved the experience. The
          quality of his work is exceptional, reflecting his dedication and attention to detail.
        </p>
      </div>
    </div>
  );
}
